import { SEO } from "gatsby-theme-core";
import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import { normalizedData } from "@streamo/helper/methods";
import { Layout, HeaderOne, FooterOne } from "gatsby-theme-layout";
import {
    PageHeader01,
    WhyChooseUsSection01,
    HowItWork01,
    FunFactArea02,
    TeamArea,
} from "gatsby-theme-container";

const AboutUsPage = ({ data }) => {
    const content = normalizedData(data?.page?.content || []);
    return (
        <Layout>
            <SEO pageName="About Us" />
            <HeaderOne data={{ ...data?.header, ...data.navigation }} />
            <PageHeader01 data={content?.["page-header-section"]} />
            <WhyChooseUsSection01 data={content?.["why-choose-us-section"]} />
            <HowItWork01 data={content?.["how-it-work-section"]} />
            <FunFactArea02 data={content?.["funfact-section"]} />
            <TeamArea data={content?.["team-section"]} />
            <FooterOne data={{ ...data?.footer, ...data?.contact }} />
        </Layout>
    );
};

export const query = graphql`
    query AboutUsTwoPageQuery {
        header: general(section: { eq: "header-01" }) {
            ...Header01
        }
        navigation: general(section: { eq: "menu-streaming" }) {
            ...Menu01
        }
        footer: general(section: { eq: "footer-01" }) {
            ...Footer01
        }
        contact: general(section: { eq: "contact" }) {
            ...Contact01
        }
        page(title: { eq: "about-us" }) {
            content {
                ...PageContent
            }
        }
    }
`;
AboutUsPage.propTypes = {
    data: PropTypes.shape({
        header: PropTypes.shape({}),
        navigation: PropTypes.shape({}),
        footer: PropTypes.shape({}),
        contact: PropTypes.shape({}),
        page: PropTypes.shape({
            content: PropTypes.arrayOf(PropTypes.shape({})),
        }),
    }),
};

export default AboutUsPage;
